import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const APP_DATE_FORMAT = "DD/MM/YY" as const;
export const APP_TIME_FORMAT = "HH:mm:ss" as const;
export const APP_DATE_TIME_FORMAT =
	`${APP_DATE_FORMAT} ${APP_TIME_FORMAT}` as const;

export function formatUtcDateTime(
	date: string | Date | null | undefined,
	tz: string,
): string {
	if (!date) return "";
	return dayjs
		.utc(date)
		.tz(tz || "UTC")
		.format(APP_DATE_TIME_FORMAT);
}

export function getUtcTimestamp(
	date: string | Date | null | undefined,
): number | null {
	if (!date) return null;
	const parsed = dayjs.utc(date);
	return parsed.isValid() ? parsed.valueOf() : null;
}
